import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetSpecificPatientState, SpecificPatient } from "./index.types";

export const initialGetSpecificPatientState: GetSpecificPatientState = {
  getSpecificPatientIsLoading: false,
  getSpecificPatientSuccess: null,
  getSpecificPatientData: null,
};

const name = "getSpecificPatient";

export const getSpecificPatientSlice = createSlice({
  name,
  initialState: initialGetSpecificPatientState,
  reducers: {
    getSpecificPatient: (state) => {
      state.getSpecificPatientIsLoading = true;
    },
    getSpecificPatientSuccess: (state, action: PayloadAction<SpecificPatient>) => {
      state.getSpecificPatientIsLoading = false;
      state.getSpecificPatientSuccess = true;
      state.getSpecificPatientData = action.payload;
    },
    getSpecificPatientFail: (state) => {
      state.getSpecificPatientIsLoading = false;
      state.getSpecificPatientSuccess = false;
      state.getSpecificPatientData = null;
    },
    clearSpecificPatientData: (state) => {
      state.getSpecificPatientIsLoading = false;
      state.getSpecificPatientSuccess = null;
      state.getSpecificPatientData = null;
    },
  },
});

export const { getSpecificPatient, clearSpecificPatientData } = getSpecificPatientSlice.actions;

export default getSpecificPatientSlice.reducer;

export const getSpecificPatientDetails = (patientId: string | number) => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/patients/${patientId}/`,
  },
  type: "getSpecificPatient",
});

export const refreshPatientData = (patientId: string | number) => ({
  payload: {
    apiName: name,
    method: "POST",
    url: `/api/patients/refresh_smart_summary/?patient_id=${patientId}`,
  },
  type: "refreshPatientData",
});
